import React, { useCallback } from 'react'
import { useTranslation } from 'react-i18next';
import { useOfferTags } from 'cityads-v3/hooks/offers';
import { ThemeProvider as MuiThemeProvider, createTheme } from '@mui/material/styles';
import darkTheme from 'cityads-v3/utils/muiTheme/darkTheme';
import { useOfferFiltersContext } from '../../OfferFilters.hooks';
import classes from './TravelBanner.scss'

import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'

export const TRAVEL_TAG = `travel`

const buttonTheme = createTheme({
  palette: {
    primary: {
      main: '#F5D13D',

    },
  },
});

export default function TravelBanner(): JSX.Element {
  const { t } = useTranslation(['main']);
  const [, tagsByCode] = useOfferTags()
  const offerFilters = useOfferFiltersContext()

  const handleSelectTag = useCallback(() => {
    if (offerFilters.selectedFilters.fields.tags.value.includes(TRAVEL_TAG)) {
      offerFilters.refresh()
    } else {
      offerFilters.selectedFilters.fields.tags.pushToArray(TRAVEL_TAG)
      offerFilters.selectedFilters.handleSubmit()
    }
  }, [offerFilters])

  if (!tagsByCode?.[TRAVEL_TAG]?.is_available_in_filter) {
    return null;
  }

  return (
    <MuiThemeProvider theme={darkTheme}>
      <div className={classes.container}>
        <div className={classes.banner}>
          <div className={classes.text}>
            <Typography
              color="textPrimary"
              variant="h6"
            >{t('travelBanner.title')}</Typography>
            <Typography color="textSecondary">{t('travelBanner.description')}</Typography>

            <MuiThemeProvider theme={buttonTheme}>
              <Button
                color="primary"
                classes={{ root: classes.button }}
                onClick={handleSelectTag}
                variant="contained"
              >{t('travelBanner.button')}</Button>
            </MuiThemeProvider>
          </div>
        </div>
      </div>
    </MuiThemeProvider>
  )
}
